import { render, staticRenderFns } from "./SearchAdsCampaignsStatsChartLegend.vue?vue&type=template&id=b6d5f8e8"
import script from "./SearchAdsCampaignsStatsChartLegend.vue?vue&type=script&lang=js"
export * from "./SearchAdsCampaignsStatsChartLegend.vue?vue&type=script&lang=js"
import style0 from "./SearchAdsCampaignsStatsChartLegend.vue?vue&type=style&index=0&id=b6d5f8e8&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports